import { useMsal } from '@azure/msal-react';
import { DEV_AUTH_BYPASS, DEV_USER } from './devAuth';

export interface CurrentUser {
  id: string;
  name: string;
  email: string;
  initials: string;
}

function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  // Take the first character of the first and last word — works for most scripts, and for a
  // single-word name falls back to just that character.
  const first = [...parts[0]][0] ?? '';
  const last = parts.length > 1 ? ([...parts[parts.length - 1]][0] ?? '') : '';
  return (first + last).toUpperCase();
}

export function useCurrentUser(): CurrentUser | null {
  const { accounts } = useMsal();

  if (DEV_AUTH_BYPASS) {
    return { ...DEV_USER, initials: initialsOf(DEV_USER.name) };
  }

  const account = accounts[0];
  if (!account) return null;

  const claims = (account.idTokenClaims ?? {}) as Record<string, unknown>;
  const name = account.name ?? (claims.name as string) ?? account.username;
  return {
    id: (claims.oid as string) ?? account.localAccountId,
    name,
    email: account.username,
    initials: initialsOf(name),
  };
}
